<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.proceed')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <hand-raise raiseSide="right" />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '../../mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import HandRaise from './HandRaise.vue';

export default {
  name: 'HandRaiseRight',
  components: {
    Screen,
    CircleWindow,
    HandRaise,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 2.5,
  }),
};
</script>
